export const SHARE_URL = 'share-url'
